import React from 'react';

import { FormattedMessage } from 'react-intl';

import { selectShipmentInsuranceFilterOptions } from '../../../services/insurance-service';
import * as messages from './messages';

const buildCriterionArgumentObject = (id, displayMessage, value) => {
  return {
    id,
    displayName: <FormattedMessage {...displayMessage} />,
    value,
  };
};

const staticCriterionArguments = (state) => {
  const insuranceOptions = selectShipmentInsuranceFilterOptions({ state });

  return {
    deliveryNotification: Object.keys(messages.EmailSentMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.EmailSentMessages[key], key),
    ),
    'is-domestic': Object.keys(messages.DestinationMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.DestinationMessages[key], key === 'domestic'),
    ),
    insurance: insuranceOptions.map((provider) => ({
      displayName: <FormattedMessage {...provider.messageDescriptor} />,
      value: provider.insuranceOptionId,
    })),
    labelPrinted: Object.keys(messages.LabelPrintedMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.LabelPrintedMessages[key], key === 'printed'),
    ),
    marketplaceNotification: Object.keys(messages.NotificationSentMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.NotificationSentMessages[key], key),
    ),
    packingSlip: Object.keys(messages.PackingSlipMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.PackingSlipMessages[key], key === 'printed'),
    ),
    rate: Object.keys(messages.RateMessages).map((key) => buildCriterionArgumentObject(key, messages.RateMessages[key], key === 'hasRate')),
    shipmentNotification: Object.keys(messages.EmailSentMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.EmailSentMessages[key], key),
    ),
    pendingCustomsDocuments: Object.keys(messages.PendingCustomsDocumentsMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.PendingCustomsDocumentsMessages[key], key === 'hasPending'),
    ),
  };
};

export default staticCriterionArguments;
